import React  from "react";
import { Pagination } from "@components";
import { Input,  Select, Radio } from "@components/form";
import {  FormProvider } from 'react-hook-form';
import { useInvoice } from "@hooks";

const Invoice = () => {

  const {
    methods, data,
    onSubmit,
    handlePageChange, handleExcelDownload, resetSearch,
    pageIndex, recordCountPerPage,
  } = useInvoice();


  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>통합 세금계산서 정보</h2>
          </div>
          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item">
                    <label>년도</label>
                    <Select
                        name="catgRegYear"
                        options={[
                          { key: "2025", name: "2025년" },
                          { key: "2026", name: "2026년" },
                          { key: "2027", name: "2027년" },
                        ]}
                        defaultOption="전체"
                        className="input-select"
                      />
                    <label>조회 조건</label>
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "교육명" },
                        { key: "1", name: "회사명" },
                        { key: "2", name: "아이디" },
                        { key: "3", name: "이름" },
                      ]}
                      defaultOption="전체"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "300px" }}
                    />

                    <label style={{marginLeft:"20px"}}>유형</label>
                    <Radio name="sourceType" label="전체" value="" />
                    <Radio name="sourceType" label="개인" value="P" />
                    <Radio name="sourceType" label="단체" value="G" />
                  </div>
                  <div className="search-btn-container">
                    <button type="submit" className="btn-search">조회</button>
                    <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
                  </div>
                </div>
              </div>
                <section className="section-wrap">
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;계산서 명단
                      <span className="total-txt">
                        {" "} | 총 <span className="red">{data?.totalCount} 건</span> 
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button title="엑셀" className="btn-excel"  onClick={handleExcelDownload}>엑셀</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                    <div className="table-box">
                    <table className="table-list" style={{width:"100%"}}>
                      <colgroup>
                        <col style={{ width: "3%" }} />   {/* No */}

                        <col style={{ width: "10%" }} />  {/* 회사명 */}
                        <col style={{ width: "5%" }} />   {/* 유형 */}
                        <col style={{ width: "5%" }} />   {/* 인원 */}
                        <col style={{ width: "5%" }} />   {/* 공급가액 */}
                        <col style={{ width: "5%" }} />   {/* 부가세 */}
                        <col style={{ width: "5%" }} />   {/* 총액 */}
                        <col style={{ width: "5%" }} />  {/* 담당자 */}
                        <col style={{ width: "7%" }} />  {/* 연락처 */}
                        <col style={{ width: "12%" }} />  {/* 이메일 */}
                        <col style={{ width: "12%" }} />  {/* 회원ID */}
                        <col style={{ width: "5%" }} />  {/* 회원명 */}
                        <col style={{ width: "10%" }} />  {/* 교육명 */}
                      </colgroup>
                      <thead>
                        <tr>
                          <th>번호</th>
                          <th>회사명</th>
                          <th>유형</th>
                          <th>인원</th>
                          <th>공급가(원)</th>
                          <th>세액(원)</th>
                          <th>총액(원)</th>
                          <th>담당자</th>
                          <th>연락처</th>
                          <th>이메일</th>
                          <th>회원ID</th>
                          <th>회원명</th>
                          <th>교육명</th>
                        </tr>
                      </thead>
                      <tbody>
                      {data?.resultList && data.resultList.length > 0 ? (
                        data.resultList.map((item, idx) => {
                          const isGroup = item.sourceType === 'G';
                          return (
                            <tr key={item.invoiceId}>
                              <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>



                              <td>{item.companyNm}</td>
                              <td>{isGroup ? '단체' : '개인'}</td>
                              <td>{item.studentCnt.toLocaleString()}</td>
                              <td>₩ {item.supplyAmt.toLocaleString()}</td>
                              <td>₩ {item.vatAmt.toLocaleString()}</td>
                              <td>₩ {item.totalAmt.toLocaleString()}</td>
                              <td>{item.taxMgrNm}</td>
                              <td>{item.taxMgrPhone}</td>
                              <td>{item.taxMgrEmail}</td>
                              <td>{isGroup ? '-' : item.memberId}</td>
                              <td>{isGroup ? '-' : item.memberNm}</td>
                              <td>{item.lectureNm}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={13} style={{ textAlign: 'center' }}>
                            조회 결과가 없습니다.
                          </td>
                        </tr>
                      )}
                    </tbody>
                    </table>
                    </div>
                  </div>
                    {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                    <Pagination
                        totalPages={Math.ceil(
                          data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                        )}
                        currentPage={pageIndex}
                        onPageChange={handlePageChange}
                        pageRangeDisplayed={10}
                    />
                    )}
                </section>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
    
  );
};

export {Invoice};
